import { MentionInputPlugin } from '@platejs/mention/react';
import type { PlateEditor } from 'platejs/react';

import { focusEditor } from './focus';

/**
 * Opens the mention combobox at the caret, whatever precedes it.
 *
 * Typing `@` only opens the combobox when the previous character is a boundary
 * (`MENTION_TRIGGER_PREVIOUS_CHAR_PATTERN`), which is what stops `foo@bar.com` from
 * becoming a mention. Clicking the toolbar button carries no such ambiguity, so it
 * skips the trigger entirely and inserts the mention input node the combobox renders
 * from, leaving the surrounding text exactly as the user left it. `trigger` matches
 * what Plate stores when the same node is created by typing.
 */
export function openMentionCombobox(editor: PlateEditor): void {
  // The mention kit is only registered when mentions are enabled; without it there is no
  // picker to mount, and the node would render as an unstyled block nothing can remove.
  if (!editor.plugins[MentionInputPlugin.key]) return;

  focusEditor(editor);
  // A never-focused editor can still have a null selection; drop the caret at the end.
  if (!editor.selection) editor.tf.select(editor.api.end([]));

  editor.tf.insertNodes({ children: [{ text: '' }], trigger: '@', type: MentionInputPlugin.key });
}
